import { render, staticRenderFns } from "./lead-details.vue?vue&type=template&id=2a8caa6a&scoped=true&"
import script from "./lead-details.vue?vue&type=script&lang=js&"
export * from "./lead-details.vue?vue&type=script&lang=js&"
import style0 from "./lead-details.vue?vue&type=style&index=0&id=2a8caa6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8caa6a",
  null
  
)

export default component.exports